const MAX_PERCENT = 100;

export const calculatePriceDiscount = (
  current: number | null | undefined,
  previous: number | null | undefined,
): number => {
  if (!current || !previous || previous <= current) return 0;
  return Math.round(((previous - current) / previous) * MAX_PERCENT);
};
